// extracted by mini-css-extract-plugin
module.exports = {"recipe":"recipe_recipe__3tV9n","elementsInList":"recipe_elementsInList__2eu7k","imageContainer":"recipe_imageContainer__3DffP","imageRound":"recipe_imageRound__hy5Gk"};